var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ew-dots",attrs:{"aria-label":_vm.label,"role":"img","title":_vm.label}},[_vm._l((_vm.dots),function(dot){return _c('span',{key:dot.key,staticClass:"ew-dot",class:`ew-dot--${dot.tone}`},[_vm._v(_vm._s(dot.short))])}),(!_vm.dots.length)?_c('span',{staticClass:"acq-tiny"},[_vm._v("–")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }